const page = 'OrdersPage';

export default page;
